import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ps-4 pb-3 my-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "99" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_localized_text, {
      type: "h5",
      localizedKey: "Land impact",
      text: "Land impact"
    }),
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Material",
              text: "Material"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Land impact (m2 land / m2 fabric)",
              text: "Land impact (m2 land / m2 fabric)"
            })
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.currentLandImpacts.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  localizedKey: "No Elements Found",
                  text: "No Elements Found"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentLandImpacts, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", null, _toDisplayString(item.material.text), 1),
            _createElementVNode("td", null, [
              (item.landImpactNOTAvailable)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "Not available",
                    text: "Not available"
                  }))
                : (item.landImpactCalculator)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$filters.currency(item.landImpactCalculator, 2)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "--"))
            ])
          ]))
        }), 128)),
        _createElementVNode("tr", _hoisted_8, [
          _createElementVNode("td", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Total",
                text: "Total"
              })
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getTotal("landImpactCalculator", _ctx.currentLandImpacts), 2)), 1)
          ])
        ])
      ])
    ])
  ]))
}